import { CryptoCoin, CoinOption } from '../types';

export const COIN_OPTIONS: Record<CryptoCoin, CoinOption> = {
  BTC: {
    id: 'BTC',
    name: 'Bitcoin',
    symbol: 'BTC',
    network: 'mainnet',
    provider: 'nowpayments',
    color: 'text-orange-500',
    confirmationTimeMin: { min: 10, max: 60 },
    explorerTxUrl: (h) => `https://mempool.space/tx/${h}`,
  },
  USDT: {
    id: 'USDT',
    name: 'Tether',
    symbol: 'USDT',
    network: 'TRC-20',
    provider: 'nowpayments',
    color: 'text-emerald-500',
    confirmationTimeMin: { min: 1, max: 5 },
    explorerTxUrl: (h) => `https://tronscan.org/#/transaction/${h}`,
  },
  LTC: {
    id: 'LTC',
    name: 'Litecoin',
    symbol: 'LTC',
    network: 'mainnet',
    provider: 'nowpayments',
    color: 'text-slate-500',
    confirmationTimeMin: { min: 5, max: 30 },
    explorerTxUrl: (h) => `https://blockchair.com/litecoin/transaction/${h}`,
  },
  XMR: {
    id: 'XMR',
    name: 'Monero',
    symbol: 'XMR',
    network: 'mainnet',
    provider: 'nowpayments',
    color: 'text-orange-400',
    confirmationTimeMin: { min: 20, max: 40 },
    explorerTxUrl: (h) => `https://xmrchain.net/tx/${h}`,
    walletWarning:
      'Some exchanges (Coinbase, Binance) block Monero withdrawals. Use a non-custodial wallet like Cake Wallet or Monerujo.',
  },
};

export const COIN_LIST: CoinOption[] = Object.values(COIN_OPTIONS);

// Inline single-character glyphs — keeps the coin picker zero-dependency.
export const COIN_ICONS: Record<CryptoCoin, string> = {
  BTC: '₿',
  USDT: '₮',
  LTC: 'Ł',
  XMR: 'ɱ',
};
